<ng-container *rxLet="vm$; let vm;">
  <app-form-select
    [formControl]="formControl"
    label="Product Type"
    [data]="vm.productTypes"
    [loading]="vm.loading"
    (itemSelected)="productTypeChanged.emit($event)"></app-form-select>
</ng-container>
